import {
  type TenantIntegrationConfigPublic,
  type TenantIntegrationConfigsPublic,
  TenantIntegrationConfigsService,
} from "@common/client"
import { makeAxiosMutation, makeNoArgsQuery, makeQuery } from "./utils"

export const tenantIntegrationsBaseKey = ["tenant-integrations"] as const

export const tenantIntegrationsQuery = makeNoArgsQuery({
  serviceCall: TenantIntegrationConfigsService.listConfigs,
  queryKey: tenantIntegrationsBaseKey,
})

export function findHubSpot(
  configs: TenantIntegrationConfigsPublic,
): TenantIntegrationConfigPublic | undefined {
  return configs.data.find((config) => config.integration === "hubspot")
}

export function findSalesforce(
  configs: TenantIntegrationConfigsPublic,
): TenantIntegrationConfigPublic | undefined {
  return configs.data.find((config) => config.integration === "salesforce")
}

export const useCreateTenantIntegrationMutation = makeAxiosMutation({
  serviceCall: TenantIntegrationConfigsService.create,
  invalidates: () => [tenantIntegrationsBaseKey],
})

export const useUpdateTenantIntegrationMutation = makeAxiosMutation({
  serviceCall: TenantIntegrationConfigsService.update,
  invalidates: () => [tenantIntegrationsBaseKey],
})

export const hubSpotConfigKey = (configId: string) =>
  ["hubspot-config", configId] as const

export const hubSpotConfigQuery = makeQuery({
  serviceCall: TenantIntegrationConfigsService.getHubspotConfig,
  queryKey: ({ config_id }) => hubSpotConfigKey(config_id),
})

export const useSetHubSpotWebhookSecretMutation = makeAxiosMutation({
  serviceCall: TenantIntegrationConfigsService.setHubspotWebhookSecret,
  invalidates: ({ config_id }) => [hubSpotConfigKey(config_id)],
})

export const hubSpotEligibilityKey = (configId: string) =>
  ["hubspot-eligibility", configId] as const

export const hubSpotEligibilityQuery = makeQuery({
  serviceCall: TenantIntegrationConfigsService.getHubspotEligibility,
  queryKey: ({ config_id }) => hubSpotEligibilityKey(config_id),
})

export const useSetHubSpotEligibilityMutation = makeAxiosMutation({
  serviceCall: TenantIntegrationConfigsService.setHubspotEligibility,
  invalidates: ({ config_id }) => [hubSpotEligibilityKey(config_id)],
})

export const hubSpotPropertyMappingKey = (configId: string) =>
  ["hubspot-property-mapping", configId] as const

export const hubSpotPropertyMappingQuery = makeQuery({
  serviceCall: TenantIntegrationConfigsService.getHubspotPropertyMapping,
  queryKey: ({ config_id }) => hubSpotPropertyMappingKey(config_id),
})

export const useSetHubSpotPropertyMappingMutation = makeAxiosMutation({
  serviceCall: TenantIntegrationConfigsService.setHubspotPropertyMapping,
  invalidates: ({ config_id }) => [hubSpotPropertyMappingKey(config_id)],
})
